import { useEffect, useState } from 'react';
import {
  Button, FormControl, FormLabel, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, Textarea,
} from '@chakra-ui/react';

/** Ventana corta para pedir un texto antes de confirmar (anular, observar). */
export default function PromptModal({ isOpen, onClose, title, description, label, confirmLabel, danger, required = true, onConfirm }) {
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) setText('');
  }, [isOpen]);

  async function confirm() {
    setSaving(true);
    try {
      await onConfirm(text.trim());
      onClose();
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="lg">{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {description && <Text fontSize="sm" color="gray.600" mb={3}>{description}</Text>}
          <FormControl isRequired={required}>
            <FormLabel htmlFor="prompt-text">{label}</FormLabel>
            <Textarea id="prompt-text" rows={3} value={text} onChange={(e) => setText(e.target.value)} />
          </FormControl>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={onClose}>Cancelar</Button>
          <Button colorScheme={danger ? 'red' : undefined} bg={danger ? undefined : '#574feb'} color="white" _hover={danger ? undefined : { bg: '#4a42d6' }} onClick={confirm} isLoading={saving} isDisabled={required && !text.trim()}>
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
